import { Component } from '@angular/core';

@Component({
  selector: 'medrecord-auth-authorization-error',
  templateUrl: './authorization-error.component.html'
})
export class AuthorizationErrorComponent {}
